module.exports = __webpack_public_path__ + "c673bdd451c48a42346f1fe894363477.png";